// extracted by mini-css-extract-plugin
export default {"container":"pending_surveys_container__1SoO6","text_white":"pending_surveys_text_white__oPjlu"};